import { render, staticRenderFns } from "./FakeDoorFormStepOne.vue?vue&type=template&id=aa8f24ac&scoped=true&"
import script from "./FakeDoorFormStepOne.vue?vue&type=script&lang=js&"
export * from "./FakeDoorFormStepOne.vue?vue&type=script&lang=js&"
import style0 from "./FakeDoorFormStepOne.vue?vue&type=style&index=0&id=aa8f24ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8f24ac",
  null
  
)

export default component.exports